import { useTheme } from "@material-ui/core";
import React, { useState } from "react";

import {
  Marker,
} from "react-simple-maps";

const AircraftMarker = (props) => {
  const {coordinates, bearing, callSign} = props;
  const theme = useTheme();
  const [state, setState] = useState({fillColor: null});
  if (theme?.palette?.primary?.main && !state.fillColor) setState({...state, fillColor: theme.palette.primary.main});
  if (!coordinates || !Array.isArray(coordinates) || coordinates.length < 2) return null;
  return (
    <Marker 
      key="aircraft"
      coordinates={coordinates}
      onClick={()=>{if (state.fillColor === theme?.palette?.primary?.main) {setState({...state, fillColor: "rgba(0,0,0,0.1)"})} else {setState({...state, fillColor: theme?.palette?.primary?.main})}}}
    >
      <g
        fill = {state.fillColor}
        stroke-width="1px"

        transform={`rotate(${bearing}), translate(-10, -10) matrix(0.127679,-0.127679,0.127,0.127,-2.75098,12.1833)`}
      >
        <path         
          stroke="rgba(0,0,0,0.5)"
          paintOrder="stroke"
          strokeWidth="5px"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          d="M83.768,23.581L78.58,28.77L80.766,44.37L83.699,41.437C84.145,40.991 84.874,40.991 85.32,41.437L87.42,43.536C87.864,43.982 87.864,44.712 87.42,45.158L81.682,50.895L83.558,64.267L86.793,61.032C87.239,60.587 87.968,60.587 88.414,61.032L90.514,63.132C90.958,63.577 90.958,64.307 90.514,64.752L84.473,70.793L86.913,88.2C87.206,90.296 86.478,92.21 84.981,93.706L83.442,95.247L61.876,45.473L47.219,60.131C44.568,62.78 41.31,65.173 37.87,67.419L40.557,85.721C40.888,87.973 40.199,90.053 38.59,91.661L37.677,92.574L28.161,73.4C26.546,74.386 24.978,75.362 23.505,76.343C24.485,74.857 25.462,73.274 26.446,71.64L7.185,62.08L8.097,61.167C9.706,59.56 11.786,58.87 14.037,59.2L32.398,61.896C34.575,58.552 36.893,55.391 39.467,52.819L54.21,38.077L4.915,16.72L6.456,15.179C7.952,13.682 9.867,12.955 11.963,13.249L29.369,15.689L35.41,9.648C35.856,9.202 36.585,9.202 37.03,9.648L39.13,11.747C39.575,12.192 39.575,12.921 39.13,13.367L35.895,16.604L49.267,18.479L55.005,12.742C55.45,12.297 56.18,12.297 56.625,12.742L58.725,14.842C59.17,15.287 59.17,16.016 58.725,16.462L55.791,19.395L70.791,21.498L73.1,19.188C74.051,18.118 75.067,17.036 76.145,15.958C84.027,8.073 92.127,3.389 94.23,5.495C96.337,7.6 91.651,15.697 83.768,23.581Z"
        />
      </g>
      {callSign?
      <text
        textAnchor="middle"
        x={0}
        y={20}
        style={{ 
          fontSize: 10, 
          fontFamily: "system-ui", 
          fill: "#000000", 
          stroke:"#eeeeee", 
          paintOrder: "stroke",
          strokeWidth: "1px",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
        }}
      >
        {callSign}
      </text> : null}
    </Marker>
  )
}
export default AircraftMarker;